type CustomerSupportErrorBannerProps = {
  error: string
  retryLabel: string
  onRetry: () => void
}

export const CustomerSupportErrorBanner = ({
  error,
  retryLabel,
  onRetry,
}: CustomerSupportErrorBannerProps) => {
  if (!error) return null

  return (
    <div className="ca-theme-transition rounded-2xl border border-(--color-status-error-border) bg-(--color-status-error-bg) px-4 py-3 text-sm text-(--color-status-error)">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span>{error}</span>
        <button
          type="button"
          onClick={onRetry}
          className="ca-theme-transition rounded-full border border-(--color-status-error-border) px-3 py-1 text-xs font-semibold hover:bg-[color-mix(in_srgb,var(--color-status-error-bg)_75%,transparent)]"
        >
          {retryLabel}
        </button>
      </div>
    </div>
  )
}
